import React from "react";
import constantes from '../../resources/constantes.json';
import styled from 'styled-components/macro';


const candidateFoto = (codcan, codpar, tipoImg) => `${constantes.rutas.candidatos}${codcan.padStart(3, '0')}-${codpar.padStart(4, '0')}-${tipoImg}.webp`;

const CardCandidate = ({horizontal, candidate, codpar, type}) => {
    const CANDIDATE_TYPE = {
			'P' : (c) => {return {nombre: c.nomcan + ' ' + c.apecan, tipo: 'Presidente' }},
			'V' : (c) => {return {nombre: c.nomcan2 + ' ' + c.apecan2, tipo: 'Vicepresidente'}}
		}
		const {nombre, tipo } = CANDIDATE_TYPE[type](candidate);
    return (
        <Candidato horizontal={horizontal}>
            <Foto
                src={candidateFoto(candidate.codcan, codpar, type)}
                alt="Imagen candidato" 
								loading="lazy" />
            <Info horizontal={horizontal}>
                <Tipo>{tipo}</Tipo>
                <Nombre>{nombre}</Nombre>
            </Info>
        </Candidato>
    )
}


const Candidato = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    justify-content:flex-start;

	@media
	screen and (max-width: 1365px) {
		width:38%;
	}

    @media
	screen and (max-width: 550px) {
		margin:1rem;
	}
`

const Foto = styled.img`
    font-size: 10px;
    max-width: 53px;
    height: 62px;
`
const Info = styled.div`
    // margin-left: 7%;
		max-width: ${({horizontal}) => horizontal ? '100%' : '125px'};
`
/** Si presidente o vice presidente */
const Tipo = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 1em;
    line-height: 13px;
    color: #979797;
`

const Nombre = styled.div`
    font-style: normal;
    font-weight: 700;
    font-size: 1.2em;
    line-height: 17px;
    color: #1C4183;
`

export default CardCandidate